/* ==========================================================================
   DIANDA TRAVEL — Homepage (Dawn) 交互脚本
   仿写参考: https://diandatravel.com/
   ==========================================================================
   设计原则：
   - 无依赖、轻量、防抖友好
   - 只做 transform / opacity 类动效，避免触发重排
   - 所有查询都限定在 .dd-home 内，避免污染其他页面
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     0. 文案解码
        Shopify 的 t 过滤器会把译文做 HTML 转义（' → &#39;、& → &amp;），
        经 json 过滤器内联进 JS 后不会自动还原，展示前统一解码一次。
     ------------------------------------------------------------------ */
  function decodeEntities(value) {
    if (value == null || value === '') return '';
    var el = document.createElement('textarea');
    el.innerHTML = String(value);
    return el.value;
  }

  function decodeMessages(messages) {
    var out = {};
    var src = messages || {};
    for (var key in src) {
      if (Object.prototype.hasOwnProperty.call(src, key)) out[key] = decodeEntities(src[key]);
    }
    return out;
  }

  /* ------------------------------------------------------------------
     1. Hero 轮播（自动播放 / 圆点 / 箭头 / 悬停暂停）
     ------------------------------------------------------------------ */
  var hero = document.querySelector('.dd-hero');
  if (hero) {
    var track = hero.querySelector('.dd-hero__track');
    var slides = hero.querySelectorAll('.dd-hero__slide');
    var dots = hero.querySelectorAll('.dd-hero__dot');
    var prevBtn = hero.querySelector('.dd-hero__arrow--prev');
    var nextBtn = hero.querySelector('.dd-hero__arrow--next');

    if (track && slides.length) {
      var current = 0;
      var total = slides.length;
      var timer = null;
      var INTERVAL = 5200;

      function goTo(index) {
        current = (index + total) % total;
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      }

      function play() {
        stop();
        timer = setInterval(function () { goTo(current + 1); }, INTERVAL);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); play(); });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); play(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); play(); });

      // 悬停时暂停，避免用户阅读时跳页
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('touchstart', stop, { passive: true });
      hero.addEventListener('touchend', play, { passive: true });

      goTo(0);
      play();
    }
  }

  /* ------------------------------------------------------------------
     2. 产品 / 文章横向轮播箭头（按卡片步进滚动）
     ------------------------------------------------------------------ */
  document.querySelectorAll('.dd-carousel').forEach(function (carousel) {
    var viewport = carousel.querySelector('.dd-carousel__viewport');
    var prev = carousel.querySelector('.dd-carousel__arrow--prev');
    var next = carousel.querySelector('.dd-carousel__arrow--next');

    if (!viewport) return;

    function step() {
      var first = viewport.querySelector('.dd-card, .dd-article');
      if (!first) return viewport.clientWidth * 0.8;
      return first.getBoundingClientRect().width + 24; // 卡片宽 + gap
    }

    function canPrev() { return viewport.scrollLeft > 8; }
    function canNext() { return viewport.scrollLeft + viewport.clientWidth < viewport.scrollWidth - 8; }

    function sync() {
      if (prev) prev.hidden = !canPrev();
      if (next) next.hidden = !canNext();
    }

    if (prev) prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      viewport.scrollBy({ left: step(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ------------------------------------------------------------------
     3. FAQ 手风琴（纯 CSS max-height 过渡 + 无障碍属性）
     ------------------------------------------------------------------ */
  document.querySelectorAll('.dd-faq__item').forEach(function (item) {
    var btn = item.querySelector('.dd-faq__q');
    var panel = item.querySelector('.dd-faq__a');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      // 关闭同组其它项
      var list = item.closest('.dd-faq__list');
      if (list) {
        list.querySelectorAll('.dd-faq__item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var openPanel = openItem.querySelector('.dd-faq__a');
            if (openPanel) openPanel.style.maxHeight = null;
            var openBtn = openItem.querySelector('.dd-faq__q');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (isOpen) {
        item.classList.remove('is-open');
        panel.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ------------------------------------------------------------------
     4. 公司介绍宣传视频（点击播放）
     ------------------------------------------------------------------ */
  document.querySelectorAll('.dd-about__play').forEach(function (play) {
    var video = play.parentElement.querySelector('video');
    if (!video) return;
    play.addEventListener('click', function () {
      video.play();
      play.classList.add('is-hidden');
      play.style.display = 'none';
    });
  });

  /* ------------------------------------------------------------------
     5. 订阅表单（JSON POST 到 Dianda 独立接口 /api/create-subscribe）
     ------------------------------------------------------------------ */
  var subscribeForm = document.getElementById('ddSubscribeForm');
  if (subscribeForm) {
    var subCfg = window.ddSubscribeConfig || {};
    var subMsgs = decodeMessages(subCfg.messages);
    var subName = subscribeForm.querySelector('input[name="name"]');
    var subEmail = subscribeForm.querySelector('input[name="email"]');
    var subBtn = subscribeForm.querySelector('.dd-subscribe__submit');
    var subStatus = document.getElementById('ddSubscribeStatus');
    // 文案来自 Liquid，先存下来，提交期间临时替换成「Subscribing…」
    var subBtnText = subBtn ? subBtn.textContent.trim() : '';
    var subBusy = false;

    function subShowStatus(kind, msg) {
      if (!subStatus) return;
      subStatus.hidden = !msg;
      if (msg) subStatus.setAttribute('data-state', kind);
      subStatus.textContent = msg || '';
    }

    function subSetBusy(on) {
      subBusy = on;
      if (!subBtn) return;
      subBtn.disabled = on;
      subBtn.textContent = on ? (subMsgs.submitting || subBtnText) : subBtnText;
    }

    function isEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    }

    if (subEmail) {
      subEmail.addEventListener('input', function () {
        subEmail.classList.remove('is-invalid');
        subEmail.removeAttribute('aria-invalid');
      });
    }

    subscribeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (subBusy) return;

      var email = subEmail ? subEmail.value.trim() : '';
      if (!isEmail(email)) {
        if (subEmail) {
          subEmail.classList.add('is-invalid');
          subEmail.setAttribute('aria-invalid', 'true');
          subEmail.focus();
        }
        subShowStatus('error', subMsgs.invalidEmail || 'Please enter a valid email address.');
        return;
      }

      if (!subCfg.apiUrl) {
        // 静默失败会让用户以为按钮坏了，必须给出可见反馈
        console.error('[dd-home] 未配置订阅接口地址，表单无法提交。');
        subShowStatus('error', subMsgs.error || 'Subscription failed. Please try again later.');
        return;
      }

      subShowStatus('', '');
      subSetBusy(true);

      fetch(subCfg.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          entry: 1,
          email: email,
          name: subName ? subName.value.trim() : '',
        }),
      })
        .then(function (res) {
          // 沿用留咨接口的响应约定 {code, msg, errors}，把失败原因照实转达；
          // 跨域被拦（本地预览）时没有可读的响应体，退回调用方给的通用文案。
          return res.text().then(function (text) {
            var data = null;
            try { data = JSON.parse(text); } catch (_) {}
            var code = data && data.code != null ? Number(data.code) : null;
            if (res.ok && (code === null || code < 400)) return;
            var detail = data && data.errors && data.errors.length
              ? data.errors.join(' / ')
              : ((data && data.msg) || ('HTTP ' + res.status));
            var err = new Error(detail);
            err.serverMsg = detail;
            throw err;
          });
        })
        .then(function () {
          subSetBusy(false);
          subscribeForm.reset();
          subShowStatus('success', subMsgs.success);
        })
        .catch(function (err) {
          subSetBusy(false);
          subShowStatus('error', (err && err.serverMsg) || subMsgs.error || 'Subscription failed. Please try again later.');
          console.error('[dd-home] 订阅提交失败：', err);
        });
    });
  }

  /* ------------------------------------------------------------------
     6. 留咨表单：手机区号下拉 + JSON POST 到 Dianda 独立接口
        - 选项来自 assets/dd-country-codes.js（[区号, ISO, 名称]，已按 A→Z 排好）
        - 默认选中访客所在国家（Liquid 内联的 ddHomeConfig.country）
        - 提交体与接口约定一致：{ entry: 1, name, email, country_code, phone, message }
          区号单独放 country_code，phone 只传号码本身（纯数字）
     ------------------------------------------------------------------ */
  var inquiryForm = document.querySelector('.dd-form-panel .dd-form');

  if (inquiryForm) {
    var inquiryCfg = window.ddInquiryConfig || {};
    var inquiryMsgs = decodeMessages(inquiryCfg.messages);
    var inquiryStatus = inquiryForm.querySelector('.dd-form__status');
    var inquirySubmit = inquiryForm.querySelector('button[type="submit"]');
    var inquirySubmitText = inquirySubmit ? inquirySubmit.textContent.trim() : '';
    var inquiryBusy = false;

    var inquiryName = inquiryForm.querySelector('[name="contact[name]"]');
    var inquiryEmail = inquiryForm.querySelector('[name="contact[email]"]');
    var inquiryPhone = inquiryForm.querySelector('[name="contact[phone]"]');
    var inquiryMessage = inquiryForm.querySelector('[name="contact[body]"]');
    var codeSelect = inquiryForm.querySelector('[data-dd-home-code]');

    // 区号下拉：数据文件没加载时保持隐藏，号码仍可单独提交
    var countryList = window.DDCountryCodes || [];
    if (codeSelect) {
      if (!countryList.length) {
        console.error('[dd-home] 未加载 assets/dd-country-codes.js，手机区号下拉未启用。');
      } else {
        var homeConfig = window.ddHomeConfig || {};
        var preferred = String(homeConfig.country || 'US').toUpperCase();
        var preferredHit = countryList.some(function (c) { return c[1] === preferred; });
        if (!preferredHit) preferred = 'US';

        var optionsHtml = '';
        for (var i = 0; i < countryList.length; i++) {
          var country = countryList[i];
          optionsHtml += '<option value="' + country[0] + '" data-iso="' + country[1] + '"' +
            (country[1] === preferred ? ' selected' : '') + '>' +
            country[1] + ' (' + country[0] + ')</option>';
        }
        codeSelect.innerHTML = optionsHtml;

        var codeWrap = codeSelect.closest('.dd-form__phone');
        if (codeWrap) codeWrap.classList.add('is-ready');
      }
    }

    function inquiryShowStatus(state, text) {
      if (!inquiryStatus) return;
      inquiryStatus.hidden = !text;
      if (text) {
        inquiryStatus.setAttribute('data-state', state);
        inquiryStatus.textContent = text;
      } else {
        inquiryStatus.removeAttribute('data-state');
        inquiryStatus.textContent = '';
      }
    }

    function inquirySetBusy(on) {
      inquiryBusy = on;
      if (!inquirySubmit) return;
      inquirySubmit.disabled = on;
      inquirySubmit.textContent = on
        ? (inquiryMsgs.submitting || 'Sending…')
        : inquirySubmitText;
    }

    function inquiryDial() {
      if (!codeSelect) return '';
      var opt = codeSelect.options[codeSelect.selectedIndex];
      return opt ? opt.value : '';
    }

    inquiryForm.addEventListener('submit', function (event) {
      // 从一开始就接管提交：即使接口没配好，也不要落到 Shopify 的默认 contact 提交
      event.preventDefault();
      if (inquiryBusy) return;

      var name = inquiryName ? inquiryName.value.trim() : '';
      var email = inquiryEmail ? inquiryEmail.value.trim() : '';
      var message = inquiryMessage ? inquiryMessage.value.trim() : '';
      var rawPhone = inquiryPhone ? inquiryPhone.value.trim() : '';
      var phone = rawPhone.replace(/\D/g, '');

      // 用户直接输入国际号码（+86 138…）时，把已选区号从号码里剥掉，避免重复
      if (rawPhone.charAt(0) === '+') {
        var dialDigits = inquiryDial().replace(/\D/g, '');
        if (dialDigits && phone.indexOf(dialDigits) === 0) phone = phone.slice(dialDigits.length);
      }

      // 原生 required 已经拦过空值，这里兜住「只输入空格 / 符号」的情况
      if (!name || !email || phone.length < 5) {
        inquiryShowStatus('error', inquiryMsgs.error || 'Submission failed. Please try again.');
        var firstBad = !name ? inquiryName : (!email ? inquiryEmail : inquiryPhone);
        if (firstBad) firstBad.focus();
        return;
      }

      if (!inquiryCfg.apiUrl) {
        // 静默失败会让用户以为按钮坏了，必须给出可见反馈
        console.error('[dd-home] 未配置留咨接口地址，表单无法提交。');
        inquiryShowStatus('error', inquiryMsgs.error || 'Submission failed. Please try again.');
        return;
      }

      inquiryShowStatus('', '');
      inquirySetBusy(true);

      fetch(inquiryCfg.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          entry: inquiryCfg.entry || 1,
          name: name,
          email: email,
          country_code: inquiryDial(),
          phone: phone,
          message: message,
        }),
      })
        .then(function (res) {
          // 接口响应约定 {code, msg}，校验失败时还带 errors 数组；跨域被拦时
          // msg 会直接说明原因（"来源域名未被允许" = 当前域名不在白名单）
          return res.text().then(function (text) {
            var data = null;
            try { data = JSON.parse(text); } catch (_) {}
            var code = data && data.code != null ? Number(data.code) : null;
            if (res.ok && (code === null || code < 400)) return;
            var detail = data && data.errors && data.errors.length
              ? data.errors.join(' / ')
              : ((data && data.msg) || ('HTTP ' + res.status));
            var err = new Error(detail);
            err.serverMsg = detail;
            throw err;
          });
        })
        .then(function () {
          inquirySetBusy(false);
          // 成功后清空表单；reset() 会把区号恢复成默认项（访客国家）
          inquiryForm.reset();
          inquiryShowStatus('success', inquiryMsgs.success || 'Thank you!');
        })
        .catch(function (err) {
          inquirySetBusy(false);
          inquiryShowStatus('error', (err && err.serverMsg) || inquiryMsgs.error || 'Submission failed.');
          console.error('[dd-home] 留咨提交失败：', err);
        });
    });
  }
})();
